import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../services/modal.service';
import { Subscription } from 'rxjs';
import { ModalArgs, ModalMessage } from '../../models/modal';

@Component({
  selector: 'lib-confirm-modal', // implemented on app.component.html
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css'],
  standalone: false
})
export class ConfirmModalComponent implements OnInit, OnDestroy {
  @ViewChild('confirmModalRef', { static: true }) public confirmModalRef: TemplateRef<any>;

  private sub: Subscription;
  public message: ModalMessage;
  public cancelText: string;
  public confirmText: string;
  public headerText: string;

  constructor(
    private modalService: ModalService,
    private ngbModalService: NgbModal
  ) {}

  ngOnInit() {
    this.sub = this.modalService.confirmModalToggle.subscribe((value: ModalArgs) => {
      this.message = value.Message;
      this.cancelText = value.CancelButtonText;
      this.confirmText = value.ConfirmButtonText;
      this.headerText = value.Header;
      this.ngbModalService
        .open(this.confirmModalRef, {
          backdrop: 'static',
          keyboard: false,
          size: 'lg',
          windowClass: 'centered'
        })
        .result.then(
          // confirm
          () => this.modalService.confirmModalCallback.next(true),
          // cancel
          () => this.modalService.confirmModalCallback.next(false)
        );
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
